"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.semanticChildrenMixin = void 0;
var _styledComponents = require("styled-components");
var _semanticElementMixin = require("./semanticElementMixin");
/** @mixin semanticChildrenMixin */
/**
 * Adds styling for semantic elements as children of the component.
 *
 * @example
 * import { semanticChildrenMixin } from '@zillow/constellation';
 *
 * const Component = styled.div`
 *     ${semanticChildrenMixin}
 * `;
 *
 * <Component>
 *    <strong>Important:</strong> Semantics <em>are</em> important!
 * </Component>
 *
 * @method
 * @return {CSSObject}
 */
var semanticChildrenMixin = function semanticChildrenMixin(props) {
  return (0, _styledComponents.css)(["strong,b{", "}em,i{", "}"], (0, _semanticElementMixin.semanticElementMixin)(Object.assign({}, props, {
    as: 'strong'
  })), (0, _semanticElementMixin.semanticElementMixin)(Object.assign({}, props, {
    as: 'em'
  })));
};
exports.semanticChildrenMixin = semanticChildrenMixin;